<template>
    <div class="s_p_img" @click="runShare()">
        <img src="@/assets/image/share_facebook.png">
        <div class="s_p_img_text">
            {{ $t('en_facebook') }}
        </div>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import shareUtil from "@/components/share/shareUtil";
import imageOption from "@/mixins/imageOption";
import EventBus from "@/utils/event-bus";

const {getShareLink, createBranchLink} = shareUtil;
export default {
    name: "ShareFacebookComponent",
    mixins: [alertMixins, imageOption],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        shareType: {default: '', },
        shareData: {
            default: {
                path: '/',
                img: 'https://testimage.minglemint.com/profileBack/no_image.jpg',
                title: `밍글민트(Minglemint NFT Marketplace)`,
                description: `밍글민트(Minglemint NFT Marketplace)`
            }
        },
        runAfter:{type: Function, default:  () => {}},
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {

    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        runShare() {
            EventBus.$emit('apiLoading', true);
            let $this = this;
            let format = this.returnExtension(this.shareData.img);
            let imgUrl = this.shareData.img + '?' + this.setImageOptions(300, 200, format);
            let img = new Image()
            img.src = imgUrl;
            img.onload = function () {
                setTimeout(() => {
                    $this.openFacebook(imgUrl);
                    document.body.removeChild(img);
                }, 500)
            }
            document.body.appendChild(img);
        },
        async openFacebook(imgUrl) {
            let shareData = {
                img: imgUrl,
                path: this.shareData.path,
                title: this.shareData.title,
                description: this.shareData.description,
            }
            let dynamicLink = await createBranchLink(shareData);
            EventBus.$emit('apiLoading', false);
            if(!dynamicLink) {
                this.errorAlert(this.$t('share_fail'));
                return false;
            }
            let facebookUrl = "http://www.facebook.com/sharer/sharer.php?u=" + dynamicLink
            window.open(facebookUrl, 'Share on Facebook', 'scrollbars=no, width=500, height=500');
        },
    },
    watch: {},

}
</script>

<style scoped>

</style>
